export default __webpack_public_path__ + "static/media/Q42021.c3010a1c.PDF";